import { lazyValue, noop } from '@proc7ts/primitives';
import { AbortedZExecutionError } from './aborted-execution-error.js';
import { execZ } from './exec.js';
import { FailedZExecutionError } from './failed-execution-error.js';
/**
 * Spawns child process.
 *
 * @param spawn - Starter function returning started child process instance.
 * @param config - Spawned process configuration.
 *
 * @returns New process execution instance killing the process on abort.
 */
export function spawnZ(spawn, config = {}) {
    const { kill } = config;
    const killProcess = typeof kill === 'function' ? kill.bind(config) : (process) => process.kill(kill);
    return execZ(() => {
        let abort;
        let whenDone = () => new Promise((resolve, reject) => {
            const childProcess = spawn();
            abort = () => {
                killProcess(childProcess);
            };
            const reportError = (error) => {
                abort = noop;
                reject(error);
            };
            childProcess.on('error', reportError);
            childProcess.on('exit', (code, signal) => {
                if (signal) {
                    reportError(new AbortedZExecutionError(signal));
                }
                else if (code) {
                    reportError(code > 127 ? new AbortedZExecutionError(code) : new FailedZExecutionError(code));
                }
                else {
                    abort = noop;
                    resolve();
                }
            });
        });
        abort = () => {
            whenDone = lazyValue(() => Promise.reject(new AbortedZExecutionError()));
        };
        return {
            whenDone() {
                return whenDone();
            },
            abort() {
                abort();
            },
        };
    });
}
//# sourceMappingURL=spawn.js.map